import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { toJSDate } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar";
import { SelectionType } from "@swimlane/ngx-datatable";
import { validarRut, VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { Cesionario } from "src/app/models/Cesion/Cesionario";
import { CesionarioFilter } from "src/app/models/Cesion/CesionarioFilter";
import { CesionRequest } from "src/app/models/Cesion/CesionRequest";
import { DetalleCesionRequest } from "src/app/models/Cesion/DetalleCesionRequest";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { PersonaAutorizada } from "src/app/models/PersonaAutorizada";
import { ResultadoImportacion } from "src/app/models/ResultadoImportacion";
import { CesionarioService } from "src/app/services/cesionario.service";
import { EmisorService } from "src/app/services/emisor.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";
import { threadId } from "worker_threads";
import { ConfigMantenedorCesionario } from "../../administracion/mantenedor-cesionario/config-mantenedor-cesionario";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
	selector: "app-cesion-dte",
	templateUrl: "./cesion-dte.component.html",
	styleUrls: ["./cesion-dte.component.scss"],
})
export class CesionDteComponent implements OnInit {
	@Input() public receivedDte: DteEmitido;
	@Output() private sendCloseRequestEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output() private sendCesionRequestEmitter: EventEmitter<CesionRequest> = new EventEmitter<CesionRequest>();
	public cesionFormGroup: FormGroup;
	public personasAutorizadasSource: PersonaAutorizada[] = [];
	public loadingCesionario: boolean = false;
	public prevSearch: string = "";
	public currentCesionario: Cesionario;
	private currentPersonaAutorizada: PersonaAutorizada;
	private cesionToSend: CesionRequest = new CesionRequest();
	private cesionarioListMoldaRef: NgbModalRef;
	public page: Page = new Page();
	public loading: boolean = false;
	private filter: CesionarioFilter = new CesionarioFilter();
	public selected = [];
	public SelectionType = SelectionType;
	public CesionariofullList: any[] = [];
	public emisorId: string;
	public configLocal = ConfigMantenedorCesionario;

	constructor(private formBuilder: FormBuilder, private cesionarioService: CesionarioService, private modalService: NgbModal, private tokenService: TokenStorageService, private sessionUserService: SessionUserService) {}

	public get fechaVencimientoEfectiva(): Date {
		if (this.receivedDte?.fechaVencimiento) {
			return this.receivedDte.fechaVencimiento;
		}
		const fechaEmision = new Date(this.receivedDte.fecha);
		fechaEmision.setDate(fechaEmision.getDate() + 30);
		return fechaEmision;
	}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		(this.emisorId = this.tokenService.getCompany()), (this.filter.activo = 1);
		this.filter.emisorId = this.emisorId;
		this.personasAutorizadasSource = this.receivedDte.emisorAsociado.personasAutorizadas;
		this.setCesionForm();
	}

	onSubmit() {
		if (this.cesionFormGroup.valid && this.currentCesionario) {
			this.cesionToSend.emisorId = this.receivedDte.emisorId;
			this.cesionToSend.dteId = this.receivedDte.dteId;
			let personaAutorizada = this.cesionFormGroup.controls.personaAutorizada.value as PersonaAutorizada;
			this.cesionToSend.personaAutorizadaCesionId = personaAutorizada.personaAutorizadaCesionId;
			this.cesionToSend.rutPersonaAutorizada = personaAutorizada.rut;
			this.cesionToSend.dvPersonaAutorizada = personaAutorizada.dv;
			this.cesionToSend.nombrePersonaAutorizada = personaAutorizada.nombre;
			this.cesionToSend.correoPersonaAutorizada = personaAutorizada.correo;
			this.cesionToSend.fechaEmision = new Date();
			// Fecha de vencimiento de la cesión (editable a futuro). Por defecto toma la del DTE
			// o, si no tiene, 30 días después de la emisión. Es la que se usa para el XML del AEC.
			this.cesionToSend.fechaVencimiento = this.fechaVencimientoEfectiva;
			this.cesionToSend.rutEmisor = this.receivedDte.rutEmisor;
			this.cesionToSend.codigoTipoDte = this.receivedDte.codigoTipoDte;
			this.cesionToSend.folio = this.receivedDte.folio;
			this.cesionToSend.montoTotal = this.receivedDte.total;
			let detalleCesion: DetalleCesionRequest = new DetalleCesionRequest();
			detalleCesion.cesionarioId = this.currentCesionario.cesionarioId;
			detalleCesion.fechaUltimoVencimiento = this.fechaVencimientoEfectiva;
			detalleCesion.correoDeudor = this.cesionFormGroup.controls.emailDeudor.value;
			detalleCesion.montoCesion = this.receivedDte.total;
			detalleCesion.declaracionJurada = this.cesionFormGroup.controls.declaracionJurada.value;
			detalleCesion.otrasCondiciones = this.cesionFormGroup.controls.otrasCondiciones.value ? this.cesionFormGroup.controls.otrasCondiciones.value : "";
			this.cesionToSend.detalleCesions = [detalleCesion];

			this.sendCesionRequestEmitter.emit(this.cesionToSend);
		}
	}

	setCesionForm() {
		this.cesionFormGroup = this.formBuilder.group({
			rutEmisor: [],
			razonSocialEmisor: [],
			direccionEmisor: [],
			rutAutorizado: [],
			nombreAutorizado: [],
			emailAutorizado: [],
			personaAutorizada: [this.personasAutorizadasSource[0], [Validators.required]],
			rutCesionario: ["", [VerificacionRutValidator, Validators.required]],
			nombreCesionario: [],
			direccionCesionario: [],
			emailCesionario: [],
			emailDeudor: [, [Validators.required]],
			declaracionJurada: [, Validators.required],
			otrasCondiciones: [],
			nombreContacto: [],
			correoContacto: [],
			fonoContacto: [],
		});
		this.currentPersonaAutorizada = this.cesionFormGroup.controls.personaAutorizada.value;
		this.changePersonaAutorizada(this.currentPersonaAutorizada);
		this.cesionFormGroup.controls.rutEmisor.patchValue(this.receivedDte.emisorAsociado.rutString);
		this.cesionFormGroup.controls.razonSocialEmisor.patchValue(this.receivedDte.emisorAsociado.razonSocial);
		this.cesionFormGroup.controls.direccionEmisor.patchValue(this.receivedDte.emisorAsociado.dirFact ? this.receivedDte.emisorAsociado.dirFact + ", " + this.receivedDte.emisorAsociado.comuna : this.receivedDte.emisorAsociado.dirPart + ", " + this.receivedDte.emisorAsociado.comuna);
	}

	buscaCesionario(rut) {
		if (!this.loadingCesionario && rut != "" && rut != null && validarRut(rut) && this.prevSearch != rut) {
			this.loadingCesionario = true;
			this.prevSearch = rut;
			this.cesionarioService.searchCesionario(rut, this.receivedDte.emisorId).subscribe(
				(result) => {
					this.loadingCesionario = false;
					if (result.data.length > 0) {
						this.currentCesionario = result.data[0];
						this.cesionFormGroup.controls.nombreCesionario.patchValue(this.currentCesionario.razonSocial);
						this.cesionFormGroup.controls.emailCesionario.patchValue(this.currentCesionario.correo);
						this.cesionFormGroup.controls.direccionCesionario.patchValue(this.currentCesionario.direccion);
						this.cesionFormGroup.controls.rutCesionario.patchValue(this.currentCesionario.rutFormateado);
						this.setDeclaracionJurada();
					} else {
						Swal.fire({
							icon: "error",
							title: "Error en Cesionario",
							text: "No fue posible obtener un cesionario con el termino buscado",
						});
					}
				},
				(error) => {
					Swal.fire({
						icon: "error",
						title: "Error en Cesionario",
						text: "No fue posible obtener un cesionario con el termino buscado",
					});
				}
			);
		} else if (!validarRut(rut) && rut != "") {
			Swal.fire({
				icon: "error",
				title: "error en busqueda",
				text: "Ingrese un rut válido para la busqueda",
			});
		}
	}

	setDeclaracionJurada() {
		let textoDeclaracion =
			"Se declara bajo juramento que " +
			this.receivedDte.emisorAsociado.razonSocial +
			", RUT " +
			this.receivedDte.emisorAsociado.rutString +
			" ha puesto a disposición del cesionario " +
			this.currentCesionario.razonSocial +
			", RUT " +
			this.currentCesionario.rutFormateado +
			" el o los documentos donde constan los recibos de las mercaderias entregadas o los servicios prestados, entregrados por parte del deudor de la factura " +
			this.receivedDte.razonSocial +
			", RUT " +
			this.receivedDte.rutReceptorDv;
		this.cesionFormGroup.controls.declaracionJurada.patchValue(textoDeclaracion);
	}
	sendCloseRequest() {
		this.sendCloseRequestEmitter.emit();
	}
	changePersonaAutorizada($event: PersonaAutorizada) {
		this.cesionFormGroup.controls.rutAutorizado.patchValue($event.rutFormateado);
		this.cesionFormGroup.controls.nombreAutorizado.patchValue($event.nombre);
		this.cesionFormGroup.controls.emailAutorizado.patchValue($event.correo);
	}
	openCesionarioListModal(cesionarioListModal) {
		this.setPage({ offset: 0 });
		this.cesionarioListMoldaRef = this.modalService.open(cesionarioListModal, {
			windowClass: "",
			size: "lg",
		});
	}

	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		this.cesionarioService.getDataByPage(this.filter, localPage).subscribe(
			(result) => {
				this.CesionariofullList = [...result.data];
				this.setPageFromResponse(this.page, result);
				this.loading = false;
			},
			(error) => {
				Swal.fire({
					title: "Error en lista",
					text: "No fue posible traer la lista de cesionarios",
					icon: "error",
				});
			}
		);
	}

	onActivate(event) {
		if (event.type == "click") {
			this.currentCesionario = event.row;
			this.cesionFormGroup.controls.nombreCesionario.patchValue(this.currentCesionario.razonSocial);
			this.cesionFormGroup.controls.emailCesionario.patchValue(this.currentCesionario.correo);
			this.cesionFormGroup.controls.direccionCesionario.patchValue(this.currentCesionario.direccion);
			this.cesionFormGroup.controls.rutCesionario.patchValue(this.currentCesionario.rutFormateado);
			this.setDeclaracionJurada();
			this.cesionarioListMoldaRef.close();
		}
	}

	setPageFromResponse(currentPage: Page, data: PagedResponse<any>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	searchElementsByFilter(event) {
		this.filter[event.criterio] = event.busqueda;
		this.filter.emisorId = this.emisorId;
		this.filter.activo = event.activo;
		this.setPage({ offset: 0 });
	}
}
